<template>
    <div class="footer-container mt-14">
        <div class="inner-container">
            <v-row>
                <v-col cols="12" md="6">
                    <div class="head_text mb-6">
                        QUICK LINKS
                    </div>
                    <v-row>
                        <v-col cols="6" sm="4" md="4">
                            <span @click="$router.push({ name: 'home', replace: true })" href="" class="link">Home</span><br>
                            <span @click="$router.push({ path: '/#pricing', replace: true })" href="" class="link">Pricing</span><br>
                            <span @click="$router.push({ name: 'partners', replace: true })" href="" class="link">Team</span><br>
                            <span @click="$router.push({ name: 'contact', replace: true })" href="" class="link">Contact</span><br>
                        </v-col>
                        <v-col cols="6" sm="8" md="8">
                            <span @click="$router.push({ name: 'About_E', replace: true })" href="" class="link">Relevant Papers</span><br>
                            <span @click="$router.push({ name: 'instructions', replace: true })" href="" class="link">Instructions</span><br>
                            <span href="" class="link">FAQs</span><br>
                            <span @click="$router.push({ name: 'About_D', replace: true })" href="" class="link">Relevant Projects</span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <div class="head_text mb-6">
                        CONTACT INFO
                    </div>
                    <div class="mt-4">
                        Email:
                        nutrisense@nutrisense.online
                        <br>
                        Phone:
                        <span class="phone">+30 697 387 6604</span>,
                        <span class="phone">+30 694 589 3830</span>

                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style scoped>
.footer-container {
    min-height: 350px;
    background: #000;
    color: #fff;
    font-size: 18px;
}
.head_text {
    color: #71a253;
    font-weight: bold;
    margin-top: 40px;
}
.inner-container {
    width: 50%;
    margin: auto;
}
.link {
    text-decoration: none;
    color: #fff;
}
span {
    cursor: pointer;
}
.phone {
    color: #c5c5c5;
    cursor: unset;
}

@media (max-width: 960px) {
    .inner-container {
        width: 90%;
    }
    .footer-container {
        font-size: 16px;
    }
}

@media (max-width: 600px) {
    .footer-container {
        font-size: 14px;
        min-height: auto;
        padding-bottom: 30px;
    }
}
</style>
